import { Button, CircularProgress, makeStyles } from '@material-ui/core';
import { ArchiveRounded as ArchiveIcon, UnarchiveRounded as UnarchiveIcon } from '@material-ui/icons';

import StatusChip from '../../../shared/components/Chips/StatusChip.component';
import { DeliveryZone } from '../../types/delivery-zone.type';

type Props = {
  deliveryZone: DeliveryZone;
  isEditing: boolean;
  isUpdating: boolean;
  canSave: boolean;
  onCancel: () => void;
  onSave: () => void;
  onArchiveActionClick: () => void;
};

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',

    '& > h2': {
      margin: 0,
    },
  },
  actions: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',

    '& .MuiButton-root': {
      textTransform: 'none',
    },
  },
  saveButton: {
    backgroundColor: theme.palette.admin.primary.main,
    color: theme.palette.admin.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.admin.primary.dark,
    },
  },
}));

export function DeliveryZoneDetailsHeader({
  deliveryZone,
  isEditing,
  isUpdating,
  canSave,
  onCancel,
  onSave,
  onArchiveActionClick,
}: Props) {
  const classes = useStyles();
  const isArchived = deliveryZone.archivedAt !== null;

  return (
    <div className={classes.header}>
      <h2>{deliveryZone.name}</h2>
      <StatusChip isActive archived={isArchived} />
      <div className={classes.actions}>
        <Button size="small" variant="text" onClick={onCancel} disabled={!isEditing || isUpdating}>
          Annuler
        </Button>
        <Button
          size="small"
          variant="contained"
          className={classes.saveButton}
          onClick={onSave}
          disabled={!canSave}
          startIcon={isUpdating ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {isUpdating ? 'Enregistrement...' : 'Enregistrer'}
        </Button>
        <Button
          size="small"
          variant="outlined"
          startIcon={isArchived ? <UnarchiveIcon /> : <ArchiveIcon />}
          onClick={onArchiveActionClick}
        >
          {isArchived ? 'Restaurer' : 'Archiver'}
        </Button>
      </div>
    </div>
  );
}
